import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetState } from '../../actions/data'
import ReactEcharts from 'echarts-for-react'
import AllocationsChart from './AllocationsChart';
import i18n from '../../i18n.js'
import './SaveConfirmation.css'

const SaveConfirmation = () => {
  const savedToDB = useSelector(state => state.data.savedToDB)
  const savingInProgress = useSelector(state => state.data.savingInProgress)
  const selectedNewModelNames = useSelector(state => state.data.selectedNewModelNames)
  const data = useSelector(state => state.data.models)
  const selectedModels = useSelector(state => state.data.selectedModels)
  const sleeveSaved = useSelector(state => state.data.sleeveSaved.swaps)

  console.log(' 1 selectedModels', selectedModels)
  console.log(' 1 selectedNewModelNames', selectedNewModelNames)
  // const originalTickers = sleeveSaved ? sleeveSaved.map(swap => swap.originalTicker) : []
  // const newTickers = sleeveSaved ? sleeveSaved.map(swap => swap.newTicker) : []

  const state = useSelector(state => state.data)
  const portfolioHubLink = '/investments/tools/#my-portfolio-hub&'
  const portfolioAnalysisLink = '/investments/tools/#portfolio-analysis&'
  const fundComparisonLink = '/investments/tools/#fund-comparison&'
  // const custommodelLink = '#custom-model&'

  const formatDate = dateString => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${month}/${day}/${year}`
  }

  const filteredData = selectedModels.map(model => {
    return data.find(item => item.ticker === model);
  }).filter(item => item !== undefined);


  console.log(' 1 filteredData', filteredData)
  const allStatuses = useSelector(state => state.data.allStatuses)

  const tickerMapping =
    sleeveSaved && sleeveSaved.swaps
      ? Object.fromEntries(
        sleeveSaved.swaps.map(swap => [swap.originalTicker, swap.newTicker])
      )
      : {}

  // We're adding an `originalIndex` property to each item in the `swappedData` array before filtering.
  // This `originalIndex` will be used later to fetch the correct name from the `selectedNewModelNames` array.
  const swappedData = filteredData.map((item, index) => {
    const holdings = item.holdings[0]
    const allocation = item.allocation.split('/').map(Number);

    return {
      ...item,
      allocation,
      originalIndex: index, // Add originalIndex property
      holdings: {
        ...holdings,
        tickers: holdings.tickers.map(ticker => tickerMapping[ticker] || ticker)
      }
    }
  })

  const filteredSwappedData = swappedData.filter((data, index) => {
    const status = allStatuses[index]
    return status && status.status === 200
  })

  const filteredSwappedDataFailures = swappedData.filter((data, index) => {
    const status = allStatuses[index]
    return status && status.status !== 200
  })
  console.log('swappedData', swappedData)
  console.log('filteredSwappedData', filteredSwappedData)
  console.log('filteredSwappedDataFailures', filteredSwappedDataFailures)
  return (
    <div>
      {savingInProgress && <div className="saving-title"> SAVING</div>}
      {allStatuses.every(status => status.status === 200 || status.status === 201) && (
        <div className='general'>
          Congratulations, your portfolios have been saved!
        </div>
      )}
      {allStatuses.some(status => status.status === 200 || status.status === 201) &&
        allStatuses.some(status => status.status !== 200 && status.status !== 201) && (
          <div className='general'>
            Congratulations, these portfolios have been saved.
          </div>
        )}

      <div className='confirm'>
        {savedToDB && (
          <div>
            <div className='model-container'>
              {filteredSwappedData.map((data, index) => (
                <div key={index} className='model-item'>
                  <h4 className='model-name'>{selectedNewModelNames[index]}</h4>
                  <AllocationsChart className="AllocationsChart" data={data.allocation} index={index} />
                </div>
              ))}
            </div>
            <div>
              {allStatuses.some(
                status => status.status === 200 || status.status === 201
              ) && (
                  <div>
                    <div className='general'>
                      {i18n.t('general_text')} {formatDate(new Date())}.
                      {i18n.t('general_text2')}
                    </div>
                    <div className='app-links'>
                      {i18n.t('portfolioHubText_1')}
                      <a href={portfolioHubLink} target='_blank' rel='noopener noreferrer'>
                        {' '}My Portfolio Hub
                      </a>.{' '}
                      <a
                        href={portfolioAnalysisLink}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Portfolio Analysis
                      </a>{' '}and{' '}
                      <a
                        href={fundComparisonLink}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Fund Comparison
                      </a>. {i18n.t('portfolioHubText_2')}
                    </div>
                  </div>
                )}
            </div>
            <div>
              {allStatuses.some(status => status.status === -1) && (
                <div className='model-failure'>
                  {i18n.t('failure_1')}
                  {i18n.t('failure_2')}
                </div>
              )}
            </div>
            {filteredSwappedDataFailures.length > 0 && (
              <div className='model-container'>
                {filteredSwappedDataFailures.map((data, index) => (
                  <div key={index} className='model-item'>
                    <h4 className='model-name'>{selectedNewModelNames[data.originalIndex]}</h4>
                    <AllocationsChart className="AllocationsChart" data={data.allocation} index={index} />
                  </div>
                ))}
              </div>
            )}
            <div className='save-button-container'>
              <button
                className='recreate'
                onClick={() => window.open('/investments/tools/#fund-comparison&', '_blank')}
              >
                Fund Comparison
              </button>
              <button
                className='recreate'
                onClick={() => window.open('/investments/tools/#my-portfolio-hub&', '_blank')}
              >
                PORTFOLIO HUB
              </button>
              <button
                className='recreate'
                onClick={() => window.open('/investments/tools/#portfolio-analysis&', '_blank')}
              >
                PORTFOLIO ANALYSIS
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default SaveConfirmation